import z from "zod";

const loginSchema = z.object({
    username: z.string()
        .min(1, "Uživatelské jméno nebylo vyplněno"),
    password: z.string()
        .min(1, "Heslo nebylo vyplněno"),
});

type LoginSchema = z.infer<typeof loginSchema>;

export {loginSchema, type LoginSchema};
